const events = require('../core/events');
const tracksApi = require('../data/creektracksapi');
const showsApi = require('../data/creekshowsapi');

// Compensate for delay via the streaming CDN
const STREAMING_DELAY = 40000; // 40 seconds

function NowPlaying() {
  var self = this;
  this.firstEvent = true;
  this.pendingTrack = undefined;
  this.lastEmittedMetadata = undefined;

  document.addEventListener(events.dataCurrentTrackInfo, function (e) {
    self.receiveTrackInfo(e.detail);
  });

  document.addEventListener(events.dataShowInfo, function (e) {
    self.receiveShowInfo(e.detail);
  });
}

NowPlaying.prototype.receiveTrackInfo = function receiveTrackInfo(data) {
  this.pendingTrack = data;
  // showsApi handles caching of show objects!
  if (data && data.show_id) {
    showsApi.fetch(data.show_id);
  } else {
    showsApi.fetchCurrent();
  }
};

NowPlaying.prototype.receiveShowInfo = function receiveShowInfo(data) {
  if (this.pendingTrack || this.pendingTrack === null) {
    this.possiblyEmitEvent(data, this.pendingTrack);
    this.pendingTrack = undefined;
  }
};

NowPlaying.prototype.possiblyEmitEvent = function possiblyEmitEvent(show, track) {
  const metadata = this.assembleMetadata(show, track);
  const metadataHash = this.metadataHash(metadata);

  // TODO: If empty, or already emitted this combo, return
  if (!metadataHash || metadataHash === this.lastEmittedMetadata) {
    return;
  }

  // On the first event, emit immediately so that data gets displayed. After that,
  // apply the streaming buffer compensation.
  const delay = this.firstEvent ? 1 : STREAMING_DELAY;
  this.firstEvent = false;

  window.setTimeout(function emitEventAfterDelay() {
    this.emitEvent(metadata);
  }.bind(this), delay);
};

NowPlaying.prototype.metadataHash = function metadataHash(data) {
  if (!data || data === {}) {
    return false;
  }

  return [data.title, data.show].join(':');
};

NowPlaying.prototype.assembleMetadata = function assembleMetadata(show, track) {
  const optionalTrack = track || {};

  if (!show || !show.title) { return null; }

  return {
    title: optionalTrack.title || show.title,
    attribution:
      optionalTrack.artist || (show.hosts.length > 0 ?
        ['with', show.hosts.map(function (host) { return host.display_name; }).join(' & ')].join(' ')
        : ''),
    // TODO: Make generic by getting station name from a config somewhere
    album: optionalTrack.album || 'BFF.FM',
    label: optionalTrack.label,
    link: optionalTrack.link || show.url,
    show: show.title,
    showUrl: show.url,
    image: (show.Image && show.Image.url) || undefined
  };
};

NowPlaying.prototype.emitEvent = function emitEvent(metadata) {
  document.dispatchEvent(new CustomEvent(events.dataNowPlayingInfo, { bubbles: false, detail: metadata }));
};

NowPlaying.prototype.interface = {
  fetchCurrent: function getNowPlaying() {
    tracksApi.fetchCurrent();
  }
};

module.exports = new NowPlaying().interface;



//////////////////
// WEBPACK FOOTER
// ./src/js/data/nowPlaying.js
// module id = 94
// module chunks = 1